import { render, staticRenderFns } from "./MoralClassList.vue?vue&type=template&id=35b9ef42&scoped=true&"
import script from "./MoralClassList.vue?vue&type=script&lang=js&"
export * from "./MoralClassList.vue?vue&type=script&lang=js&"
import style0 from "./MoralClassList.vue?vue&type=style&index=0&id=35b9ef42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b9ef42",
  null
  
)

export default component.exports